// extracted by mini-css-extract-plugin
export default {"Stranger":"styles_Stranger__WsD36","fadeIn":"styles_fadeIn__7SeNs"};